import { Line } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';
import moment from "moment";

import {
    Chart as ChartJS,
    CategoryScale, 
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Legend,
    TimeScale,
    TimeSeriesScale,
    Filler,
    Tooltip,
    LogarithmicScale,
} from 'chart.js';

const BaseScale = ChartJS.registry.getScale('linear');

class CustomScale extends BaseScale {
    constructor(cfg) {
        super(cfg);
        this._startValue = -10;
        this._endValue = 100;
        
    }

    determineDataLimits() {
        this.min = this._startValue;
        this.max = this._endValue;
        
    }

    buildTicks() {
        const ticks = [];
        for (let i = this.min; i <= this.max; i += 10) {
            ticks.push({ value: i, label: `${i}%` });
        }
        
        return ticks;
    }

    generateTickLabels(ticks) {
        if(this.id === "y2"){
            ticks.forEach(tick => tick.label = "");
        }else{
            ticks.forEach(tick => tick.label = `${tick.value}`);
        }
        
        
    }

    getPixelForValue(value) {
        const width = this.isHorizontal() ? this.width : this.height;

        const region1Start = this.min; 
        const region1End = 10;
        const region2Start = 10;
        const region2End = 50;
        const region3Start = 50;
        const region3End = this.max;

        const region1Factor = 0.1;
        const region2Factor = 0.6;
        const region3Factor = 0.2; 

        const totalFactor = region1Factor + region2Factor + region3Factor;

        let pixel;
        if (value >= region1Start && value <= region1End) {
            const regionRange = region1End - region1Start;
            const relativeValue = (value - region1Start) / regionRange;
            pixel = relativeValue * (region1Factor / totalFactor) * width;
        } else if (value > region2Start && value <= region2End) {
            const regionRange = region2End - region2Start;
            const relativeValue = (value - region2Start) / regionRange;
            pixel = (region1Factor / totalFactor) * width +
                relativeValue * (region2Factor / totalFactor) * width;
        } else if (value > region3Start && value <= region3End) {
            const regionRange = region3End - region3Start;
            const relativeValue = (value - region3Start) / regionRange;
            pixel = (region1Factor / totalFactor) * width +
                (region2Factor / totalFactor) * width +
                relativeValue * (region3Factor / totalFactor) * width;
        }
        
        return this.isHorizontal() ? this.left + pixel : this.bottom - pixel;
        
    }

    getValueForPixel(pixel) {
        const range = this.max - this.min;
        const width = this.isHorizontal() ? this.width : this.height;
        const region1Start = this.min;
        const region1End = 10;
        const region2Start = 10;
        const region2End = 50;
        const region3Start = 50;
        const region3End = this.max;

        const region1Factor = 0.2;
        const region2Factor = 0.6;
        const region3Factor = 0.2;

        const totalFactor = region1Factor + region2Factor + region3Factor;
        
        let value;
        if (pixel <= (region1Factor / totalFactor) * width) {
            const relativePixel = pixel / ((region1Factor / totalFactor) * width);
            value = region1Start + relativePixel * (region1End - region1Start);
        } else if (pixel > (region1Factor / totalFactor) * width && pixel <= (region1Factor / totalFactor) * width + (region2Factor / totalFactor) * width) {
            const relativePixel = (pixel - (region1Factor / totalFactor) * width) / ((region2Factor / totalFactor) * width);
            value = region2Start + relativePixel * (region2End - region2Start);
        } else {
            const relativePixel = (pixel - (region1Factor / totalFactor) * width - (region2Factor / totalFactor) * width) / ((region3Factor / totalFactor) * width);
            value = region3Start + relativePixel * (region3End - region3Start);
        }

        
        

        return this.isHorizontal() ?  value + '%' : this.bottom - value + "%";
    }
}

CustomScale.id = 'CustomScale';
CustomScale.defaults = {};

ChartJS.register(
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    PointElement,
    LineElement,
    Title,
    Legend,
    TimeScale,
    TimeSeriesScale,
    Filler,
    Tooltip,
    CustomScale
);



export const LineChartDetailsCard = ({datasets, labels, minimumFractionDigits = 0,  type, local}) => {

    const getOrCreateLegendList = (chart, id) => {
        if(chart.canvas.id === "canvaIDall"){
            const legendContainer = document.getElementById(id);
            let listContainer = legendContainer.querySelector('ul');
          
            if (!listContainer) {
              listContainer = document.createElement('ul');
              listContainer.style.display = 'flex';
              listContainer.style.flexDirection = 'row';
              listContainer.style.margin = 0;
              listContainer.style.padding = 0;
          
              legendContainer.appendChild(listContainer);
            }
            return listContainer;
        }
        return [];
       
      };
      
      const htmlLegendPlugin = {
        id: 'htmlLegend',
        afterUpdate(chart, args, options) {
            

            if(chart.canvas.id === "canvaIDall"){
                const ul = getOrCreateLegendList(chart, options.containerID);
                ul.style.display = "flex";
                ul.style.height = "100%";
                ul.style.flexWrap = "wrap";
                ul.style.flexDirection = 'column-reverse';
                ul.style.alignContent = "center";

      
               
                while (ul.firstChild) {
                  ul.firstChild.remove();
                }
                const items = chart.options.plugins.legend.labels.generateLabels(chart);
      
                items.forEach(item => {
                 
                  if(item.text !== "Ar-Condicionado Ligado" && item.text !== "Porta Fechada" && item.text !== ""){
                      const li = document.createElement('li');
                      li.style.alignItems = 'center';
                      li.style.cursor = 'pointer';
                      li.style.display = 'flex';
                      li.style.flexDirection = 'row';
                      if(item.text !== 'Temp P' && item.text !== 'Umid P' && item.text !== 'CO2'){
                        li.style.marginLeft = '10px';
                      }
                      else if(item.text === 'Temp P'){
                        li.style.marginLeft = '10px';
                      }
                      else if(item.text === 'Temp Média'){
                        li.style.marginLeft = '10px';
                      }
                      else if(item.text === 'Umid P'){
                        li.style.marginLeft = '50px';
                      }
                      else if(item.text === 'CO2'){
                        li.style.marginLeft = '50px';
                      }
      
                      li.onclick = () => {
                        const {type} = chart.config;
                        if (type === 'pie' || type === 'doughnut') {
                          chart.toggleDataVisibility(item.index);
                        } else {
                            chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
                        }

                        if(item.text === "Temp P" && item.hidden === false){
                            const newListAverage = items.filter((element, index) => element.text === "Temp Média");
                            const newListTempS = items.filter((element, index) => element.text === "Temp S");

                            if (newListAverage[0].datasetIndex !== -1) {
                                chart.setDatasetVisibility(newListAverage[0].datasetIndex, true);
                            }
                            if (newListTempS[0].datasetIndex !== -1) {
                                chart.setDatasetVisibility(newListTempS[0].datasetIndex, false);
                            }
                        }
                        if(item.text === "Temp P" && item.hidden === true){
                            const newListAverage = items.filter((element, index) => element.text === "Temp Média");
                            const newListTempS = items.filter((element, index) => element.text === "Temp S");
                
                            if (newListAverage[0].datasetIndex !== -1) {
                                chart.setDatasetVisibility(newListAverage[0].datasetIndex, false);
                            }
                            if (newListTempS[0].datasetIndex !== -1) {
                                chart.setDatasetVisibility(newListTempS[0].datasetIndex, true);
                            }
                        }
                        if(item.text === "Temp S" && item.hidden === false){
                            const newListAverage = items.filter((element, index) => element.text === "Temp Média");
                            const newListTempP = items.filter((element, index) => element.text === "Temp P");

                            if (newListAverage[0].datasetIndex !== -1) {
                                chart.setDatasetVisibility(newListAverage[0].datasetIndex, true);
                            }
                            if (newListTempP[0].datasetIndex !== -1) {
                                chart.setDatasetVisibility(newListTempP[0].datasetIndex, false);
                            }
                        }
                        if(item.text === "Temp S" && item.hidden === true){
                            const newListAverage = items.filter((element, index) => element.text === "Temp Média");
                            const newListTempP = items.filter((element, index) => element.text === "Temp P");


                            if (newListAverage[0].datasetIndex !== -1) {
                                chart.setDatasetVisibility(newListAverage[0].datasetIndex, false);
                            }
                            if (newListTempP[0].datasetIndex !== -1) {
                                chart.setDatasetVisibility(newListTempP[0].datasetIndex, true);
                            }
                        }
                        if(item.text === "Temp Média" && item.hidden === false){
                            const newListTempP = items.filter((element, index) => element.text === "Temp P");
                            const newListTempS = items.filter((element, index) => element.text === "Temp S");

                            if (newListTempP[0].datasetIndex !== -1) {
                                chart.setDatasetVisibility(newListTempP[0].datasetIndex, true);
                            }
                            if (newListTempS[0].datasetIndex !== -1) {
                                chart.setDatasetVisibility(newListTempS[0].datasetIndex, true);
                            }
                        }
                        if(item.text === "Temp Média" && item.hidden === true){
                            const newListTempP = items.filter((element, index) => element.text === "Temp P");
                            const newListTempS = items.filter((element, index) => element.text === "Temp S");

                            if (newListTempP[0].datasetIndex !== -1) {
                                chart.setDatasetVisibility(newListTempP[0].datasetIndex, false);
                            }
                            if (newListTempS[0].datasetIndex !== -1) {
                                chart.setDatasetVisibility(newListTempS[0].datasetIndex, false);
                            }
                        }
                        chart.update();
                      };
                
                      const boxSpan = document.createElement('span');
                      if(item.text === 'Temp P' ){
                          boxSpan.style.background = item.fillStyle;
                          boxSpan.style.borderColor = item.strokeStyle;
                          boxSpan.style.borderWidth = item.lineWidth + 'px';
                          boxSpan.style.display = 'inline-block';
                          boxSpan.style.flexShrink = 0;
                          boxSpan.style.height = '2px';
                          boxSpan.style.marginRight = '10px';
                          boxSpan.style.width = '30px';
                          boxSpan.style.marginTop = '10px';

                      }else if(item.text === 'Umid P' || item.text === 'Temp E'){
                        boxSpan.style.background = item.fillStyle;
                        boxSpan.style.borderColor = item.strokeStyle;
                        boxSpan.style.borderWidth = item.lineWidth + 'px';
                        boxSpan.style.display = 'inline-block';
                        boxSpan.style.flexShrink = 0;
                        boxSpan.style.height = '2px';
                        boxSpan.style.marginRight = '10px';
                        boxSpan.style.width = '30px';
                        boxSpan.style.marginTop = '10px';
                      }else if(item.text === 'Temp Média'){
                        boxSpan.style.background = item.fillStyle;
                        boxSpan.style.borderColor = item.strokeStyle;
                        boxSpan.style.borderWidth = item.lineWidth + 'px';
                        boxSpan.style.display = 'inline-block';
                        boxSpan.style.flexShrink = 0;
                        boxSpan.style.height = '2px';
                        boxSpan.style.marginRight = '10px';
                        boxSpan.style.width = '30px';
                        boxSpan.style.marginTop = '10px';
                      }else if(item.text === 'Temp S' || item.text === 'Umid S'){
                        boxSpan.style.borderColor = item.strokeStyle;
                        boxSpan.style.borderWidth = item.lineWidth + 'px';
                        boxSpan.style.display = 'inline-block';
                        boxSpan.style.flexShrink = 0;
                        boxSpan.style.borderStyle = 'dashed';
                        boxSpan.style.height = '0.5px';
                        boxSpan.style.marginRight = '10px';
                        boxSpan.style.width = '30px';
                        boxSpan.style.marginTop = '10px';     
                      }else{
                        boxSpan.style.background = item.fillStyle;
                        boxSpan.style.borderColor = item.strokeStyle;
                        boxSpan.style.borderWidth = item.lineWidth + 'px';
                        boxSpan.style.borderRadius = '4px';
                        boxSpan.style.display = 'inline-block';
                        boxSpan.style.flexShrink = 0;
                        boxSpan.style.height = '20px';
                        boxSpan.style.marginRight = '10px';
                        boxSpan.style.width = '30px';
                        boxSpan.style.marginTop = '10px';
                      }
                      
                
                      const textContainer = document.createElement('p');
                      textContainer.style.color = item.fontColor;
                      textContainer.style.fontSize = "20px";
                      textContainer.style.fontFamily = "Arial";
                      textContainer.style.fontWeight = "bold";
                      textContainer.style.padding = 0;
                      textContainer.style.marginBottom = '8px';

                      textContainer.style.textDecoration = item.hidden ? 'line-through' : '';
                
                      const text = document.createTextNode(item.text);
                      textContainer.appendChild(text);
                
                      li.appendChild(boxSpan);
                      li.appendChild(textContainer);
                      ul.appendChild(li);
                      
                  }
                });
      
            }

        }
      };
      
      
    const options = {
        
        type: 'line',
        maintainAspectRatio: false,
        responsive: true,
        animation: false,
        aspectRatio: 1,
        showTooltips: true,
        elements: {
            point:{
                radius: 0,
                
            }
        },
        
        plugins: {
            tooltip: {
                enabled: true,
                backgroundColor: 'rgb(255,255,255)',
                titleColor: '#000000',
                bodyColor: '#000000',
                caretPadding: 100,
                position: 'nearest',
                usePointStyle: true,
                borderColor: 'rgb(106, 106, 106)',
                borderWidth: 0.5,
                callbacks: {
                    title: function(context) {
                        if(type !== "all"){
                            
                            context[0].label = moment(context[0].label, "MMM DD, YYYY, h:mm:ss a").format("DD/MM/YY HH:mm:ss"); 
                            if (context.length > 0 && context.length < 2){
                                context[0].formattedValue = "";
                            } else if (context.length === 2){
                                context[0].formattedValue = "";
                                context[1].formattedValue = "";
                            } else if (context.length === 3){
                                context[0].formattedValue = "";
                                context[1].formattedValue = "";
                                context[2].formattedValue = "";
                            } else if (context.length > 3){
                                context[0].formattedValue = "";
                                context[1].formattedValue = "";
                                context[2].formattedValue = "";
                                context[3].formattedValue = "";
                            }
                        }else{
                            context[0].label = moment(context[0].label, "MMM DD, YYYY, h:mm:ss a").format("DD/MM/YY HH:mm:ss");
                        }
                        
                    },
                    label: function(context){
                        if(context.dataset.label === "Porta Fechada"){
                            context.formattedValue = "";
                        }
                        else if(context.formattedValue.includes('.')){

                        }else{
                            const value = parseFloat(context.formattedValue.replace(',', '.'));
                            if(context.dataset.label === ""){
                             context.formattedValue = "";
                            } else if(context.formattedValue.length < 7){
                                const formattedValue = isNaN(value) ? context.formattedValue : value.toFixed(2);
                                context.formattedValue = formattedValue;
                            }
                        }
                        
                    },
                   
                }
                
              },
              htmlLegend: {
                containerID: 'legend-container',
              },
            legend: {
                position: 'top',
                align:'center',
                display: type === "all" ? false : true,
                labels: {
                    usePointStyle: true,
                    generateLabels: function(chart) {
                      const defaultLabels = ChartJS.defaults.plugins.legend.labels.generateLabels(chart);
                      const updatedLabels = defaultLabels.map(label => {
                        
                        if (label.text === '') {
                          label.lineCap = 'butt';
                          label.fillStyle = 'rgba(0, 0, 0, 0)';
                          label.lineWidth = 0;
                          label.onClick = () => {};             
                        }else if(label.text === 'Temp P'){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgba(246, 167, 104)'; 
                        } else if (label.text === 'Temp S' || label.text === 'Temp S'){
                            label.padding = 10;     
                            label.fontColor =  'rgba(246, 167, 104)';
                        } else if (label.text === 'Temp E'){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgba(255, 62, 62)';
                        } else if (label.text === 'Temp Média'){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgba(189, 117, 7)';
                        } 
                        else if (label.text === 'Umid P'){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgb(122, 140, 255)';   
                        } else if (label.text === 'Umid S' || label.text === 'Umid S'){
                            label.padding = 10;
                            label.fontColor = 'rgb(122, 140, 255)';   
                        } else if (label.text === 'CO2'){
                            label.padding = 10;
                            label.textAlign = 'center';
                            label.textBaseline = 'middle';
                            label.fontColor = 'rgba(0, 179, 52, 0.7)';   
                        } else if (label.text === "  Ar-Condicionado Ligado"){
                            label.fontColor = 'rgba(220, 120, 0)';
                        } else if(label.text === "  Porta Fechada"){
                            label.fontColor = 'rgb(12, 100, 0)';
                        } else if(label.text === "Limite Inf" || label.text === "Limite Sup"){
                            label.text = '';
                        } else if (label.text === "Porta Aberta" || label.text === "Ar-Condicionado Desligado"){
                            label.text = '';
                        }
                        return label;
                      });
          
                      return updatedLabels;
                    },
                    font:{
                        size: local === "report" ? 16 : 20,
                        family:'Arial',
                        weight: 'bold'
                    }
                  }
                
            },

        
        },

        hover: {
            mode: "nearest",
            intersect: true,
        },
        interaction: {
          mode: "index",
          intersect: false,
        },

        scales: {
            x: {
                type:'time',
                time: {
                
                    unit: 'minute',

                },
                grid: {
                    display: type === "all" ? false : false,
                    drawOnChartArea: type === "all" ? false : false,
                    drawTicks: type === "all" ? true : false,
                    lineWidth: 0.5,

                },
                border: {
                    display: false
                },
                offsetAfterAutoskip: true,
                ticks: {
                    source: 'auto',
                    display: type === "all" ? true : false,
                    maxRotation: 90,
                    minRotation: 90,
                    autoSkip: true,
                    autoSkipPadding: 3,
                    font:{
                        size : 12
                      },
                    stepSize: 2,
                    color: "rgb(0, 0, 0)",
                    callback: (value, index, values) => {
                        const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
                        return formattedDate;
                      },

                    
                },
            },
            y: {
                
                type: type === "all" ? 'CustomScale' : 'linear',
                align: 'center',
                clip: true,
                display: true,
                position: 'left',
                beginAtZero: true,
                min: type === "all" ? -10: 0,
                max: type === "all" ? 100 : 1,
                suggestedMin: 50,
                suggestedMax: 100,
                stackWeight: type === "all" ? 1 : 0.6,
                title:{
                    display: true,
                    text: type === "all" ? 'Umidade [%]' : "",
                    color: 'rgb(0, 121, 239)' ,
                    font:{
                        size: 20,
                        family:'Arial',
                        weight: 'bold',
                    }

                },
                border: {
                    display: type === "all" ? true: false,
                },
                grid: {
                    drawOnChartArea: type === "all" ? false: false,
                    display: type === "all" ? false: false,
                    drawTicks: type === "all" ? false: false,
                    offset: false,
                    
                },
                
                ticks: {
                    stepSize: type === "all" ? 10 : 1,
                    callback: function(val) {
                        
                        if(type !== "all"){
                            if( val === 0){
                                return "A/C"
                            }else if( val === 1){
                                return "P"
                            }else{
                                return "";
                            }

                        }
                        else if(type === "all" && val === -10){
                            return "";
                        }
                        return val.toLocaleString('pt-BR', { minimumFractionDigits });       
                      },
                    color:  function(context){
                        if(context.tick.label === "A/C"){
                            return "rgb(220, 120, 0)";
                        }else if (context.tick.label === "P"){
                            return "rgb(12, 100, 0)";
                        }else{
                            return "black";
                        }
                    },
                    font: {
                        size: type === "all" ? 12 : 15,
                    },
                    
                },
                
               
                
            },
            y2: {
                type: 'CustomScale',
                align: 'center',
                display: true,
                position: 'left',
                min: type === "all" ? -10 : 0,
                max: type === "all" ? 110 : 3,
                title:{
                    display: true,
                    text: type === "all" ? 'Temperatura [ºC]' : "",
                    color: 'rgba(243, 126, 34)',
                    
                    font:{
                        size: 20,
                        family:'Arial',
                        weight: 'bold'
                    }
                },
                border: {
                    display: type === "all" ? false: false,
                },
                grid: {
                    drawOnChartArea: type === "all" ? false: false,
                    display: type === "all" ? false: false,
                    drawTicks: type === "all" ? false: false,
                },              
                ticks: {
                    
                    callback: function(val) {
                        if(type !== "all"){
                            if( val === 0){
                                return "A/C"
                            }else if( val === 1){
                                return "P"
                            }else{
                                return "";
                            }

                        }
                        else if(type === "all" && val === -10){
                            return "";
                        }
                        return val.toLocaleString('pt-BR', { minimumFractionDigits });       
                      },
                },
                
            },
            y1: {
                
                type: 'linear',
                align: 'center',
                display: true,
                position: 'right',
                min: type === "all" ? -500 : 0,
                max: type === "all" ? 5000 : 3,
                stackWeight: type === "all" ? 1.04 : 0.6,
                title:{
                    display:  true,
                    text: type === "all" ? "Nivel de CO2 [PPM] " : "",
                    color: 'rgba(0, 179, 52, 0.7)',
                    font:{
                        size: 20,
                        family:'Arial',
                        weight: 'bold',
                    }
                },
                border: {
                    display: type === "all" ? true: false,
                },
                grid: {
                    drawOnChartArea: type === "all" ? true: false,
                    display: type === "all" ? false: false,
                    drawTicks: type === "all" ? true: false,
                },              
                ticks: {
                    stepSize: type === "all" ? 500 : 1,
                    callback: function(value, index) {
                        if(type !== "all"){
                            return "         ";
                        }else if (type ==="all" && value === -500){
                            return "";
                        }else{
                            return value.toLocaleString('pt-BR', { minimumFractionDigits });
                        }
                        
                    },
                    color: "black",
                    font:{
                      size : 12
                    },
                },
             
            },
           
        }
    };

    const data = {
        labels: labels ,
        datasets: datasets,
    };
    

    return (
       <Line id={`canvaID${type}`} options={options} data={data} plugins={[htmlLegendPlugin]}/>
    );
}